import { type FC, useState } from 'react';

import SaveButton from '@editor2/components/SaveButton';
import TabsOpenedCounter from '@editor2/components/TabsOpenedCounter';
import ActiveChanges from '@editor2/components/ActiveChanges';
import PresenceNotifications from '@editor2/components/PresenceNotification';

import { rightPanel } from './styles';
import { useSelector } from 'react-redux';
import { type RootState } from '@editor2/reducers/root';
import { useEventListener } from '@editor2/hooks/useEventListener';
import { getCourseTabsOpened } from '@editor2/services/editorTabsService';

interface Props {
	courseId: number;
}

const SideOptionsPanel: FC<Props> = (props) => {
	const { courseId } = props;

	const { canUpdateResource } = useSelector((state: RootState) => state.courses[courseId].policies);

	const [tabsOpened, setTabsOpened] = useState(getCourseTabsOpened(courseId));

	const storageHandler = () => {
		const tabsOpened = getCourseTabsOpened(courseId);
		setTabsOpened(tabsOpened);
	};

	useEventListener('storage', storageHandler);

	return (
		<div className={rightPanel}>
			<div className={`buttonsBlock ${canUpdateResource ? '' : 'indent'}`}>
				{canUpdateResource && <SaveButton courseId={courseId} />}

				<TabsOpenedCounter tabsOpened={tabsOpened} />
			</div>

			<div className="activeChangesBlock">
				<ActiveChanges courseId={courseId} />
			</div>

			<div className="presenceBlock">
				<PresenceNotifications courseId={courseId} />
			</div>
		</div>
	);
};

export default SideOptionsPanel;
